import React, { useState, useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CERTIFICATE_URL, COURSES_URL, PROGRAMMINGSERVICE_URL } from '../../../Services/courseService';
import axios from 'axios';
import Certificate from '../../EnrolledCourses/Certificate';
import FeedbackPopup from './Feedback';

const InterviewResults = () => {
  const { id, courseName } = useParams();
  const [courseTitle, setCourseTitle] = useState(localStorage.getItem(`reportScores_${id}_title`) || null);
  const [certificateSaved, setCertificateSaved] = useState(false);
  const [showCertificationOverlay, setShowCertificationOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [certificateData, setCertificateData] = useState(null);
  const navigate = useNavigate();
  const [isOnlyQuizInterview, setIsOnlyQuizInterview] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem("hasVisited")) {
      sessionStorage.setItem("hasVisited", "true");
      window.location.reload();
    } else {
      sessionStorage.removeItem("hasVisited");
    }

  }, []);


  const userId = localStorage.getItem('userId');
  const fullName = localStorage.getItem("fullName");
  const reportScores = localStorage.getItem(`reportScores-${id}-${userId}`) ? JSON.parse(localStorage.getItem(`reportScores-${id}-${userId}`)) : { result: 'Fail', accuracy: '0.00%', correctAnswers: 0, incorrectAnswers: 10, totalQuestions: 10 };
  const interviewId = localStorage.getItem(`${id}-interviewId`);
  const email = localStorage.getItem('email');

  console.log("reportscores", reportScores)
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(true);

  const handleClosePopup = () => {
    setShowFeedbackPopup(false);
  };


  const fetchEnrolledCourse = async () => {
    try {
      const courseDetailResponse = await fetch(`${COURSES_URL}/course/${id}`);
      if (!courseDetailResponse.ok) {
        throw new Error('Network response was not ok');
      }
      const courseDetail = await courseDetailResponse.json();
      const title = courseDetail?.data?.title || 'Unknown Course';


      localStorage.setItem(`reportScores_${id}_title`, title);


      setCourseTitle(title);
      console.log("fetchEnrolledCourse", title);

    } catch (err) {
      console.error('Error fetching course details', err);
      setCourseTitle('Unknown Course');
    }
  };

  const saveCertificateData = async () => {
    if (reportScores?.finalResult === 'Pass' && courseTitle) {
      try {
        const params = {
          userId,
          userName: fullName,
          courseId: id,
          courseName: courseTitle,
          completionDate: new Date().toLocaleDateString(),
        };
        await axios.post(`${CERTIFICATE_URL}/certificates/store`, null, { params });

        fetchCertificateData();
      } catch (error) {
        console.error('Error saving certificate:', error);
      }
    }
  };

  const fetchCertificateData = async () => {
    try {
      const response = await axios.get(`${CERTIFICATE_URL}/certificates/data?userId=${userId}&courseId=${id}`);
      if (response.status === 200) {
        setCertificateData(response.data);
      }
    } catch (err) {
      console.error('Error fetching certificate data, calling saveCertificateData:', err);
      await saveCertificateData();
      setCertificateData(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!courseTitle) {
      fetchEnrolledCourse();
    } else {
      setLoading(false);
    }

    fetchCertificateData();
  }, [userId, id, reportScores?.result, reportScores?.finalResult, courseTitle]);

  useEffect(() => {
    if (certificateSaved) {
      fetchCertificateData();
      fetchEnrolledCourse();
    }
  }, [certificateSaved]);



  useEffect(() => {
    const targetLanguages = ["python", "c", "c++", "java"];

    const escapeRegex = (str) =>
      str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  
    const decodedCourseName = decodeURIComponent(courseName);
  
    const courseNameLower = decodedCourseName.toLowerCase();
  
    const match = targetLanguages.some((lang) => {
      const escapedLang = escapeRegex(lang.toLowerCase());
      const regex = new RegExp(`\\b${escapedLang}\\b`, 'i');
      return regex.test(courseNameLower);
    });
  
    if (decodedCourseName && match) {
      setIsOnlyQuizInterview(false);
    } else {
      setIsOnlyQuizInterview(true);
    }
  }, [courseName]);
  


  return loading ? <p>Loading interview data...</p> : (
    <div className="result-container">
      {
        isOnlyQuizInterview ? <h2>{reportScores?.result === 'Pass' ? 'Congratulations!' : 'Better luck next time!'}</h2>
          : <h2>{reportScores?.finalResult === 'Pass' ? 'Congratulations!' : 'Better luck next time!'}</h2>
      }      <div className="profile-section">
        {/* <img src="/profile.jpg" alt="Profile" className="profile-pic" /> */}
        <div className="details">
          <p><strong>Name:</strong> {fullName || 'Guest'}</p>
          <p><strong>Interview Type:</strong> AI Technical</p>
          {/* <p><strong>Performance:</strong> {reportScores?.finalResult === 'Pass' ? 'Excellent' : 'Poor'}</p> */}

          {
            reportScores?.result && (
              <>
                <h4>Interview Results (Audio-Based)</h4>

                <p><strong>Confidence Feedback:</strong> {reportScores?.confidenceFeedback}
                  <span>
                    <Link to={`/${id}/interview-confidence-level`} className="interview-btn-link">
                      (Know How AI Checks Confidence Level)
                    </Link>
                  </span>
                </p>

                <p><strong>Accuracy:</strong> {reportScores?.accuracy}
                  <span>
                    <Link to={`/${id}/interview-accuracy`} className="interview-btn-link">
                      (Know How AI Checks Accuracy)
                    </Link>
                  </span>
                </p>

                <p><strong>Correct Answers:</strong> {reportScores?.correctAnswers}</p>
                <p><strong>Incorrect Answers:</strong> {reportScores?.incorrectAnswers}</p>
                {
                  isOnlyQuizInterview && <p><strong>Result:</strong> {reportScores?.result}</p>
                }
              </>)
          }

          {
            reportScores?.isFailed && (
              <>
                <h4>Coding Interview Results</h4>
                <p><strong>Result:</strong> {reportScores?.message}</p>

              </>
            )
          }
          {reportScores?.finalResult && (
            <>
              <h4>Coding Interview Results</h4>

              <p><strong>Correct Coding Answers:</strong> {reportScores?.correctCodingAnswers}</p>
              <p><strong>Incorrect Coding Answers:</strong> {reportScores?.incorrectCodingAnswers}</p>
              <p><strong>Coding Accuracy:</strong> {reportScores?.codingAccuracy}</p>
              <p><strong>Result:</strong> {reportScores?.finalResult}</p>

            </>
          )
          }


        </div>
      </div>
      <div className='interview-result-btn-container'>


        {
          (!isOnlyQuizInterview && reportScores?.finalResult === 'Pass') ||
            (isOnlyQuizInterview && reportScores?.result === 'Pass') ? (
            <button className="certificate-btn" onClick={() => setShowCertificationOverlay(true)}>
              View Certificate
            </button>
          ) : (
            <button className="certificate-btn" onClick={() => navigate(`/enrolledCourse/ai-interview/${id}/${courseName}`)}>
              Retake the exam
            </button>
          )
        }


        <button className="certificate-btn" onClick={() => navigate("/")}>Go to Home</button>

      </div>
      {
        showCertificationOverlay && (
          <div className="overlay-certificate">
            <div className="overlay-certificate-content">
              <p className="close-certificate-button" onClick={() => setShowCertificationOverlay(false)}>
                <AiOutlineClose />
              </p>
              <h2>Congratulations!</h2>
              {certificateData && (
                <Certificate userId={userId} courseId={id} />
              )}
            </div>
          </div>)
      }

      {showFeedbackPopup && (
        <FeedbackPopup
          interviewId={interviewId}
          userId={userId}
          userName={fullName}
          userEmail={email}
          onClose={handleClosePopup} // Pass the handleClosePopup function as the onClose prop
        />
      )}
    </div>
  );
};

export default InterviewResults;
